import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ConsentType } from '@core/services/cookie-consent/cookie-consent.config';
import { ThirdPartyLoaderComponent } from '../third-party-loader/third-party-loader.component';
import { NgIf } from '@angular/common';
import { LoadingDotsComponent } from '@shared/loading-dots/loading-dots.component';

@Component({
    selector: 'app-meta-live-shopping',
    templateUrl: './meta-live-shopping.component.html',
    styleUrls: ['./meta-live-shopping.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LoadingDotsComponent, NgIf, ThirdPartyLoaderComponent]
})
export class MetaLiveShoppingComponent {
    @Input() public metaLiveShoppingScriptUrl?: string;
    @Input() public consent: ConsentType;
}
